export default __webpack_public_path__ + "static/media/devto-logo.0cb51c1e.svg";